export default "__VITE_ASSET__BeYaYP6r__"